<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <h3 class="primary--text">{{ $t('business') }}</h3>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn icon small color="primary" @click="setShowDialog(false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Optional tab note -->
    <v-row>
      <v-col>
        <span class="caption grey--text">{{ $t('please_add_detail') }}</span>
      </v-col>
    </v-row>

    <ProfileForm
      :profileToEdit="profileToEdit"
      :editProfile="editProfile"
      :createProfile="createProfile"
      :setShowDialog="setShowDialog"
    />
  </v-container>
</template>

<script>
import ProfileForm from './ProfileForm.vue'

export default {
  name: 'ProfileTabs',
  components: {
    ProfileForm
  },
  props: {
    profileToEdit: Object,
    pageProfile: Number,
    getProfilesData: Function,
    editProfile: Function,
    createProfile: Function,
    setShowDialog: Function
  },
  data() {
    return {
      tab: 'profile'
    }
  },
  computed: {
    isAdmin() {
      return this.profileToEdit?.channel_member_role?.name === 'ADMIN'
    }
  }
}
</script>
